<template>
 <a :data-dusk="dataDuskSelector" @click.prevent="onTitleClick" ref="self">
   {{ cellProps }}
 </a>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: "TitleCell",
  props: {
    cellProps: {
      type: String,
      required: false,
    },
    row: {
      type: Object,
      required: false,
    }
  },
  methods: {
    ...mapMutations(`$_customer_page`, {
      setShowViewNoteModal: 'SET_SHOW_VIEW_NOTE_MODAL',
      setViewNoteId: 'SET_VIEW_NOTE_ID',
    }),
    onTitleClick() {
      this.setViewNoteId(this.row.id);
      this.setShowViewNoteModal(true);
    }
  },
  computed: {
    dataDuskSelector() {
      return `note-title-${this.row?.id}`
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
